var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.955 3.05392C19.32 2.85892 18.65 3.20892 18.455 3.84392L11.255 27.0439C11.06 27.6789 11.41 28.3489 12.045 28.5439C12.68 28.7389 13.35 28.3889 13.545 27.7539L20.745 4.55392C20.94 3.91892 20.59 3.24892 19.955 3.05392ZM23.525 8.97892C23.07 9.46392 23.095 10.2239 23.58 10.6739L29.045 15.7989L23.58 20.9239C23.095 21.3789 23.07 22.1389 23.525 22.6189C23.98 23.0989 24.74 23.1289 25.22 22.6739L31.62 16.6739C31.86 16.4489 32 16.1289 32 15.7989C32 15.4689 31.865 15.1489 31.62 14.9239L25.22 8.92392C24.735 8.46892 23.975 8.49392 23.525 8.97892ZM8.475 8.97892C8.02 8.49392 7.26 8.46892 6.78 8.92392L0.38 14.9239C0.135 15.1489 0 15.4689 0 15.7989C0 16.1289 0.135 16.4489 0.38 16.6739L6.78 22.6739C7.265 23.1289 8.025 23.1039 8.475 22.6189C8.925 22.1339 8.905 21.3739 8.42 20.9239L2.955 15.7989L8.42 10.6739C8.905 10.2189 8.93 9.45892 8.475 8.97892Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestApi);
export default __webpack_public_path__ + "static/media/rest-api.a22173378255a8c10bb125e3699292f4.svg";
export { ForwardRef as ReactComponent };